/* eslint-disable @next/next/no-script-component-in-head */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { type ReactNode, useEffect, useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import { useSession, SessionProvider } from "next-auth/react";
import type { AppProps } from "next/app";

import { hotjar } from "react-hotjar";

import { api } from "~/utils/api";
import Head from "next/head";
import "~/styles/globals.css";
import { RecoilRoot } from "recoil";
import { stopLoading } from "~/utils/flutter";
import Script from "next/script";
import { ConfigProvider } from "antd";
import SetAppVersion from "~/components/Components/SetAppVersion/SetAppVersion";

declare global {
  interface Window {
    toFlutter: any;
    fromFlutter: any;
    flutter_inappwebview: any;
    __NEXT_ROUTER__: any;
  }
}

interface IJsonData {
  action: string;
  value?: any;
}

export const sendToFlutter = (jsonData: IJsonData) => {
  if (jsonData.action === "LOGOUT") {
  }

  try {
    window.flutter_inappwebview.callHandler(
      "toFlutter",
      JSON.stringify(jsonData),
    );
  } catch (e) {
    console.log("aFlutter 용 Function 입니다");
  }
};

const ProtectRoutes = ({ children }: { children: ReactNode }) => {
  const { data: session } = useSession();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    // if (session !== undefined) {
    //   //로그아웃 상태
    //   if (!session?.user) {
    //     // if (pathname !== "/login" && pathname !== "/emailLogin") {
    //     //   router.replace("/login");
    //     // }
    //   }
    //   // //로그인 상태
    //   else if (session?.user) {
    //     // if (pathname === "/login" || pathname === "/emailLogin") {
    //     //   router.replace("/");
    //     //   return;
    //     // }
    //     if (
    //       pathname !== "/walkStart" &&
    //       localStorage.getItem("isWalking") === "true"
    //     ) {
    //       // alert("산책을 종료해 주세요");
    //       router.push("/walkStart");
    //       return;
    //     }
    //   }
    // }

    stopLoading();
  }, [session, pathname]);

  return children;
};

const MyApp = ({ Component, pageProps }: AppProps) => {
  const [viewportContent, setViewportContent] = useState<string>(
    "width=375, user-scalable=no",
  );

  useEffect(() => {
    hotjar.initialize(3792510, 6);

    const content =
      window.outerWidth > 500
        ? "width=device-width, user-scalable=no"
        : "width=375, user-scalable=no";
    setViewportContent(content);

    // ios 에서는 페이지 전환시 캐싱된 페이지를 보여주고, 이때 pathname 변화도 감지하지 못함
    // 페이지 전환시 캐싱된 페이지를 보여주지 않으려면 다음 코드 필요.
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  }, []);

  return (
    <>
      <Head>
        <meta name="viewport" content={viewportContent} />
      </Head>

      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#13c2c2",
          },
        }}
      >
        <SessionProvider session={pageProps.session}>
          <RecoilRoot>
            <ProtectRoutes>
              <Component {...pageProps} />
              <SetAppVersion />
            </ProtectRoutes>
          </RecoilRoot>
        </SessionProvider>
      </ConfigProvider>

      <Script
        id="flutter"
        dangerouslySetInnerHTML={{
          __html: `
          function fromFlutter(jsonData){
            let data = JSON.parse(jsonData);


            if (data.action === 'GET_DEVICE_CODES') {
              let div = document.getElementById('GET_DEVICE_CODES_DIV');
              if (div) {
                  div.title = jsonData;
                  div.click();
              }
            }

            if (data.action === 'GET_BEACON_DEVICE_CODE') {
              let div = document.getElementById('GET_BEACON_DEVICE_CODE_DIV');
              if (div) {
                  div.title = data.value;
                  div.click();
              }
            }

            if (data.action === 'REMOVE_BEACON_DEVICE_CODE') {
              let div = document.getElementById('REMOVE_BEACON_DEVICE_CODE_DIV');
              if (div) {
                  div.title = data.value;
                  div.click();
              }
            }

            if (data.action === 'GET_MY_LOCATION') {
              let div = document.getElementById('GET_MY_LOCATION_DIV');
              if (div) {
                  div.title = jsonData;
                  div.click();
              }
            }

            if (data.action === 'GET_MY_LOCATION_POOP') {
              let div = document.getElementById('GET_MY_LOCATION_POOP_DIV');
              if (div) {
                  div.title = jsonData;
                  div.click();
              }
            }

            if (data.action === 'GET_OS') {
              let div = document.getElementById('GET_OS_DIV');
              if (div) {
                  div.title = data.value;
                  div.click();
              }
            }

            if (data.action === 'GET_WALK_INFO') {
                let div = document.getElementById('GET_WALK_INFO_DIV');
                if (div) {
                    div.title = jsonData;
                    div.click();
                }
            }

            if (data.action === 'GET_APP_VERSION') {
              let div = document.getElementById('GET_APP_VERSION_DIV');
              if (div) {
                  div.title = data.value;
                  div.click();
              }
            }

            if (data.action === 'GOTO_PET_CODE_WITH_PET_ID') {
              let petId = data?.value ?? "";
              window.location.href = "/petCode?petId=" + petId;
            }

            if (data.action === 'GOTO_PET_CODE') {
              window.location.href = "/petCode";
            }

            if (data.action === 'GOTO_PET_REG') {
              let deviceCode = JSON.parse(jsonData)?.deviceCode ?? "";
              let deviceUUID = JSON.parse(jsonData)?.deviceUUID ?? "";
              let petId = JSON.parse(jsonData)?.petId ?? "";
              
              if(deviceCode && deviceUUID &&
                window.location.pathname === "/petDetail")
              {
                let div = document.getElementById('REG_DEVICE_CODE_DIV');
                if (div) {
                    div.title = jsonData;
                    div.click();
                }
              }
              else if(deviceCode && petId
                && window.location.pathname === "/homeMyPet")
              {
                let div = document.getElementById('REG_DEVICE_CODE_DIV');
                if (div) {
                    div.title = jsonData;
                    div.click();
                }
              }
              else if(
                deviceCode && (
                  window.location.pathname === "/home" ||
                  window.location.pathname === "/homeFindLost"
                )
              )
              {
                let div = document.getElementById('SCAN_DEVICE_CODE_DIV');
                if (div) {
                    div.title = deviceCode;
                    div.click();
                }
              }
              else if(
                window.location.pathname === "/home" ||
                window.location.pathname === "/homeMyPet"
              )
              {
                let href = "/petReg/0?deviceCode=" + deviceCode + "&deviceUUID=" + deviceUUID;
                window.location.href = href;
              }
            }

            if (data.action === 'EDIT_PET') {
              let div = document.getElementById('EDIT_PET_DIV');
              if (div) {
                  div.click();
              }
            }

            if (data.action === 'DELETE_PET') {
              let div = document.getElementById('DELETE_PET_DIV');
              if (div) {
                  div.click();
              }
            }

            if (data.action === 'SIGN_OUT') {
              let div = document.getElementById('SIGN_OUT_DIV');
              if (div) {
                  div.click();
              }
            }
          } 
			`,
        }}
      />
    </>
  );
};

export default api.withTRPC(MyApp);
